import { render, staticRenderFns } from "./LearningUnitPartDescription.vue?vue&type=template&id=5a139d44&scoped=true&"
import script from "./LearningUnitPartDescription.vue?vue&type=script&lang=js&"
export * from "./LearningUnitPartDescription.vue?vue&type=script&lang=js&"
import style0 from "./LearningUnitPartDescription.vue?vue&type=style&index=0&id=5a139d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a139d44",
  null
  
)

export default component.exports